import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Spinner } from "react-bootstrap";
import { BASE_URL } from "./Baseurl";



const AllCustomForm = ({ eventUniqueId }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [selectedForms, setSelectedForms] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUserId = localStorage.getItem("visitor_id");
    setUserId(storedUserId);
  }, []);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const res = await axios.get(`${BASE_URL}getFormsByEventId/${eventUniqueId}`);
        setSelectedForms(res.data.forms || []);
      } catch (error) {
        console.error("Error fetching forms:", error);
      } finally {
        setLoading(false);
      }
    };

    if (eventUniqueId) fetchForms();
  }, [eventUniqueId]);

  const handleButtonClick = (formId) => {
    if (userId) {
      navigate(`/forms/${formId}/${eventUniqueId}`);
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <div className="text-center my-4">
        <Button className="followbtn linkedin-btn" onClick={() => setShowModal(true)}>
          Register Now
        </Button>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        dialogClassName="linkedin-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal-title-custom">Choose Registration Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : selectedForms.length === 0 ? (
            <div className="text-center text-muted">No registration forms available.</div>
          ) : (
            <div className="form-button-group ">
              {selectedForms.map((form) => (
                <Button
                  key={form.id}
                  variant="light"
                  className="form-btn"
                  onClick={() => handleButtonClick(form.id)}
                >
                  Register as <strong>{form.formtype}</strong>
                </Button>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AllCustomForm;